"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BusSideOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var BusSideOutlineSVG = function BusSideOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M29,5H3A2,2,0,0,0,1,7V22a2,2,0,0,0,2,2H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a2,2,0,0,0,2-2V7A2,2,0,0,0,29,5ZM21,7h8a0,0,0,0,1,0,0v6H21ZM3,7A0,0,0,0,1,3,7H19v6H3ZM9,25a2,2,0,1,1,2-2A2,2,0,0,1,9,25Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,25Zm6-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H3s0-7,0-7H29S29,22,29,22Z"
  }));
};
exports.BusSideOutlineSVG = BusSideOutlineSVG;
BusSideOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(BusSideOutlineSVG);
exports.default = _default;